<template>
  <div>
    <add-new-promotion @refresh="refetchCodes" />
    <!-- <br>
    <br>
    <br>
    <br>
    <br>
     <form class="topform" @submit.prevent="addPromotion()">
      <input
        type="radio"
        id="ORDER_DISCOUNT"
        value="ORDER_DISCOUNT"
        v-model="type"
      />
      <label for="ORDER_DISCOUNT">Zniżka procentowa</label>
      <br />
      <input
        type="radio"
        id="WALLET_MONEY"
        value="WALLET_MONEY"
        v-model="type"
      />
      <label for="WALLET_MONEY">Zniżka na zamówienie w zł</label>
      <br />
      <div class="input-container" style="margin-top: 30px">
        <label>Kod promocyjny</label>
        <input
          v-model="code"
          id="title"
          type="text"
          class="form-control"
          required
          minlength="5"
          maxlength="12"
        />
      </div>
      <div>
        <label v-if="type === 'WALLET_MONEY'">Wartość podana w zł</label>
        <label v-if="type === 'ORDER_DISCOUNT'">Wartość podana w %</label>
        <input
          v-if="type === 'WALLET_MONEY'"
          v-model="value"
          id="title"
          type="number"
          class="form-control"
          required
          min="1"
        />
        <input
          v-if="type === 'ORDER_DISCOUNT'"
          v-model="value"
          id="title"
          type="number"
          class="form-control"
          required
          min="1"
          max="99"
        />
      </div>

      <div class="mt-3">
        <label>Data wygaśnięcia promocji</label>
      </div>
      <div class="datepickers">
        <datepicker
          :monday-first="true"
          :language="pl"
          v-model="expiration_date"
          name="expiration_date"
          :placeholder="'Wybierz datę'"
          required
        ></datepicker>
      </div>
      <button class="btn btn-outline-dark" type="submit">Zapisz</button>
    </form>  -->

    <div class="codes">
      <div class="flex">
        <button
          class="btn btn-sm btn-outline-dark mr-2"
          @click="handleFilter(null)"
        >
          Wszystkie
        </button>
        <button
          class="btn btn-sm btn-outline-dark mr-2"
          @click="handleFilter(true)"
        >
          Aktywne
        </button>
        <button
          class="btn btn-sm btn-outline-dark mr-2"
          @click="handleFilter(false)"
        >
          Nieaktywne
        </button>
      </div>
      <table class="table borderless" v-if="codes && codes.length > 0">
        <thead></thead>
        <tbody>
          <tr
            v-for="code in codes"
            :key="code.id"
            :style="
              isFuture(code.expiration_date)
                ? 'background:  #99ffb3'
                : 'background:#ffb3b3'
            "
          >
            <td>{{ code.code }}</td>
            <td>
              {{
                code.type === "WALLET_MONEY"
                  ? `${code.value}zł`
                  : `${parseFloat(code.value * 100).toFixed(0)}%`
              }}
            </td>
            <td>
              {{
                code.type === "ORDER_DISCOUNT"
                  ? "Zniżka procentowa"
                  : "Zniżka na zamówienie w zł"
              }}
            </td>
            <td class="dateRow">
              {{ formattedDate(code.expiration_date) }}
              <div class="datepickerInCol">
                <datepicker
                  :language="pl"
                  :ref="`editDatepickerRef${code.id}`"
                  :id="`expiration_date${code.id}`"
                  :name="`expiration_date${code.id}`"
                  :placeholder="'Edytuj datę'"
                  required
                  @input="handleEditExpirationDate($event, code)"
                ></datepicker>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import axios from "../../axios";
import shared from "../../shared";
import { pl } from "vuejs-datepicker/dist/locale";
import AddNewPromotion from "../../components/AddNewPromotion.vue";
export default {
  components: { Datepicker, AddNewPromotion },
  name: "Promotions",
  data() {
    return {
      pl: pl,
      code: "",
      value: "",
      type: "ORDER_DISCOUNT",
      expiration_date: "",
      edittedDate: "",
      filter: null,
    };
  },
  created() {
    this.isFuture = shared.isFuture;
    this.formattedDate = shared.formattedDateWithoutTime;
    this.$store.dispatch("getAllCodes");
  },
  methods: {
    refetchCodes() {
      this.$store.dispatch("getAllCodes");
    },
    handleFilter(filter) {
      this.filter = filter;
      this.$store.dispatch("getAllCodes", filter);
    },
    handleEditExpirationDate(event, code) {
      axios
        .put(`/api/promotionalCode/${code.id}`, {
          type: code.type,
          value: code.value,
          code: code.code,
          expiration_date: event.getTime() / 1000,
        })
        .then(() => {
          this.$notify({
            group: "success",
            text: "Pomyślnie zmieniono datę ważności kodu",
          });
          this.$store.dispatch("getAllCodes");
          (this.value = ""), (this.code = ""), (this.expiration_date = "");
        });
    },
    addPromotion() {
      const date = new Date(this.expiration_date);
      if (!this.expiration_date) {
        return this.$notify({
          group: "error",
          text: "Wybierz datę ważności kodu",
        });
      }
      if (!this.isFuture(this.expiration_date)) {
        return this.$notify({
          group: "error",
          text: "Wybierz prawidłową datę ważności",
        });
      }
      let valueToSet = this.value;
      if (this.type === "ORDER_DISCOUNT") {
        valueToSet = this.value / 100;
      }
      axios
        .post(`/api/promotionalCode`, {
          type: this.type,
          value: valueToSet,
          code: this.code,
          expiration_date: date.getTime() / 1000,
        })
        .then(() => {
          this.$notify({
            group: "success",
            text: "Kod został dodany",
          });
          this.$store.dispatch("getAllCodes");
          (this.value = ""), (this.code = ""), (this.expiration_date = "");
        })
        .catch((err) => {
          console.log(err.response.data[0].error);
          if (err.response.data[0].error === "code_already_exist") {
            this.$notify({
              group: "error",
              text: "Taki kod już istnieje",
            });
          }
        });
    },
  },
  computed: {
    codes() {
      return this.$store.getters.getAllPromotionalCodes;
    },
  },
};
</script>

<style scoped>
.topform input {
  margin-right: 5px;
}
.topform {
  text-align: center;
  margin: 0 auto;
  width: 300px;
  text-align: left;
}
.topform button {
  width: 100%;
}
.codes {
  margin-top: 40px;
}
.datepickerInCol input {
  border: 1px solid grey;
  border-radius: 5px;
  padding: 10px;
  width: 100px;
  height: 20px;
}
.dateRow {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dateRow div {
  padding: 0;
}
.codes {
  text-align: center;
}
.codes > .flex button {
  margin-bottom: 10px;
  width: 30%;
}
</style>
